import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {sendHashedEmailEvent} from '@optimaxdev/analytics/desktop/lib/sendHashedEmailEvent/index';
import {Tooltip} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {CHECKOUT_GENERAL} from 'constants/analytics/events/checkout';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';

import s from './authHelper.scss';

/**
 * AuthHelper for checkout page
 *
 * @constructor
 */
const AuthHelper: React.FC = () => {
    const customer = useGetCustomerData();
    const dispatch = useHostDispatch();

    const sendAnalyticsCallback = (message: string) => {
        sendDesktopAnalyticsEvent(CHECKOUT_GENERAL, {
            message,
        });
    };

    const onSignInClick = () => {
        dispatch({
            payload: {
                tab: 'login',
                visible: true,
            },
            type: 'AUTH_POPUP@SET_VISIBLE',
        });
        sendAnalyticsCallback('Login');
    };

    const clearCheckoutData = () => {
        sendAnalyticsCallback('Logout');
        sendHashedEmailEvent(customer.email, {isCleanUp: true});
        dispatch({type: 'OAUTH@SIGN_OUT'});
    };

    return customer?.is_logged_in ? (
        <>
            Logged as {customer.email}{' '}
            <div className={s.wrapper}>
                <Tooltip
                    content={
                        <div className={s.tooltipContainer}>
                            <span className={classNames(s.email, s.item)} title={customer.email}>
                                {customer.email}
                            </span>
                            <button
                                className={classNames(s.logout, s.link, s.item)}
                                onClick={clearCheckoutData}
                                type="button"
                            >
                                Logout
                            </button>
                        </div>
                    }
                    position="bottom"
                >
                    <div className={s.link}>Edit</div>
                </Tooltip>
            </div>
        </>
    ) : (
        <>
            Already have a GlassesUSA account?{' '}
            <button className={s.link} onClick={onSignInClick} type="button">
                Sign in here
            </button>
        </>
    );
};
export default AuthHelper;
